import React, { useCallback, useMemo, useEffect, useRef, useState } from 'react';
import ResizeObserver from 'resize-observer-polyfill';
import PropTypes from "prop-types";
import moment from "moment";
import { Tooltip } from "devextreme-react/tooltip";
import {
    BsChevronBarLeft,
    BsChevronBarRight,
} from "react-icons/bs";


import {
    TimelineContainer,
    TimelineConstants,
    TimelineRod,
    AltTimelineRod,
    TimelineThumbOuter,
    AltTimelineThumbOuter,
    TimelineThumbInner,
    AltTimelineThumbInner,
} from './Timeline.Styled';
import { fill } from 'lodash';


const TimelineItemCategory = {
    PANO:1,
    DESIGN:2,
};

const TimelineItemTemplate = {
    id:0,
    active:false,
    date: null,
    position: 0.0,
    category: -1
};



function Timeline(props) {

    const { startDate, endDate } = props;

    const containerRef = useRef();
    const observerRef = useRef();

    const [ state, setState ] = useState({
        thumbs:[],

        svgPath:'',
        svgWidth:0,
        svgHeight:0,
    });


    // const onResize = (entries) => {
    //     console.log(entries)
    // };


    useEffect(() => {
        observerRef.current = new ResizeObserver(onResize);

        observerRef.current.observe(containerRef.current);

        return () => {
            observerRef.current.disconnect();
        }
    }, []);


    const onResize = (entries) => {
        const w = entries[0].contentRect.width;
        generateSVGRod(w, 4, 6);
    };


    const toDateString = (date) => {
        const md = moment(date)
        const d = `00${md.date()}`;
        const m = `00${md.month()+1}`;
        const w = `00${md.isoWeek()}`;

        return "W" + w.substring(w.length - 2) + "\n" +
               md.format('DD MMM').toUpperCase()
        ;
        //
        // return d.substring(d.length - 2) + '.' +
        //        m.substring(m.length - 2) + ' W' +
        //        w.substring(w.length - 2)
        //     ;
    };


    const generateSVGRod = useCallback((width, rodWidth, beakSize) => {

        const w = width - 2 * rodWidth;
        const startDate = moment(props.startDate);
        const endDate = moment(props.endDate);
        const interval = moment.duration(endDate.diff(startDate));
        const weeks = interval.asWeeks() - 1;
        const iweeks = Math.ceil(weeks);

        const rodHalfWidth = rodWidth / 2.0;

        let path =
            `M${width-rodWidth},${beakSize}` +
            `c${rodHalfWidth},0 ${rodWidth},${rodHalfWidth} ${rodWidth},${rodWidth}` +
            `l-${width},0` +
            `c0,-${rodHalfWidth} ${rodHalfWidth},-${rodWidth} ${rodWidth},-${rodWidth}`
            ;

        if (iweeks > 1) {

            path +=
                `l${beakSize},-${beakSize} ${beakSize},${beakSize}`
            ;

            let wDist = (w - 2 * beakSize) / iweeks;
            let dw = 1;

            // if (wDist < 32 && iweeks > 3) {
            //     wDist = l / Math.floor(iweeks / 2);
            //     dw = 2
            // }

            for (let wi = 0; wi <= iweeks-dw; wi += dw) {
                path +=
                    `l${(wDist-2*beakSize).toFixed(2)},0` +
                    `l${beakSize},-${beakSize} ${beakSize},${beakSize}`
                ;
            }
        }

        path +=
            `Z`
        ;

        setState(old => ({
            ...old,
            svgPath:path,
            svgWidth: width,
            svgHeight: rodWidth + beakSize
        }));
    }, [startDate, endDate, setState])


    useEffect(() => {

        const tlId = props.id || ('TL-' + Math.floor(Math.random() * 0xFFFFFF).toString(16).toUpperCase());

        const thumbs = props.items.map(i => {

            const id = `${tlId}-D${i.id}`;
            const p = Math.floor(i.position * 100.0 + 0.5);
            const tt = `${toDateString(i.date)}`;
            const cn = i.category === 2 ? "auxiliary" : "";

            return (
                <div
                    key={id}
                >
                    {i.category === 1 &&
                        <>
                            <TimelineThumbOuter
                                id={id}
                                style={{
                                    left:`calc(${p}% - ${TimelineConstants.ThumbOuterDia / 2}px)`,
                                    top:`calc(50% - ${TimelineConstants.ThumbOuterDia / 2}px)`,
                                    borderWidth: (i.active ? 4 : 1)
                                }}
                                onClick={e => props.onItemClick && props.onItemClick(i)}
                            />
                            <TimelineThumbInner
                                style={{
                                    left:`calc(${p}% - ${TimelineConstants.ThumbInnerDia / 2}px)`,
                                    top:`calc(50% - ${TimelineConstants.ThumbInnerDia / 2}px)`,
                                }}
                            />
                        </>
                    }
                    {i.category === 2 &&
                        <>
                            <AltTimelineThumbOuter
                                id={id}
                                style={{
                                    left:`calc(${p}% - ${TimelineConstants.ThumbOuterDia / 2}px)`,
                                    top:`calc(50% - ${TimelineConstants.ThumbOuterDia / 2}px)`,
                                    borderWidth: (i.active ? 4 : 1)
                                }}
                                onClick={e => props.onItemClick && props.onItemClick(i)}
                            />
                            <AltTimelineThumbInner
                                style={{
                                    left:`calc(${p}% - ${TimelineConstants.ThumbInnerDia / 2}px)`,
                                    top:`calc(50% - ${TimelineConstants.ThumbInnerDia / 2}px)`,
                                }}
                            />
                        </>
                    }
                    <Tooltip
                        className={cn}
                        target={`#${id}`}
                        animation={null}
                        position={props.toolTipPosition}
                        contentRender={evt => {
                            const lines = tt.split('\n');
                            return (<><span><b>{lines[0]}</b></span><br/><span>{lines[1]}</span></>);
                        }}
                        showEvent={{
                            name:'mouseenter',
                            delay:250
                        }}
                        hideEvent={{
                            name:'mouseleave',
                            delay:250
                        }}
                    >
                        {tt}
                    </Tooltip>
                </div>
            );
        });


        setState(old => ({...old,
            thumbs
        }));

    }, [props.items, setState]);


    return (
        <TimelineContainer
            id={"timeline-container"}
            ref={containerRef}
            style={{
                position: 'absolute',
                left:0,
                top:0,
                right: 0,
                bottom:0,
            }}
        >
            { props.kind === 'pano' &&
                <>
                <svg
                    width={state.svgWidth}
                    height={state.svgHeight}
                    style={{
                        position: 'absolute',
                        top:0,
                        transform:'scaleY(-1)'
                    }}
                >
                    <path d={state.svgPath}
                          style={{fill:TimelineConstants.Color}} />
                </svg>
                <TimelineRod
                    style={{
                        left:'16px',
                        // top:`calc(50% - ${TimelineConstants.RodWidth / 2}px)`,
                        bottom:TimelineConstants.ThumbOuterDia/2,
                        width:`calc(100% - 32px)`
                    }}
                >
                    {state.thumbs}
                </TimelineRod>
                </>
            }
            { props.kind === 'design' &&
                <>
                <svg
                    width={state.svgWidth}
                    height={state.svgHeight}
                    style={{
                        position: 'absolute',
                        bottom:0,
                    }}
                >
                    <path d={state.svgPath}
                          style={{fill:TimelineConstants.AltColor}} />
                </svg>
                <AltTimelineRod
                    style={{
                        left:16,
                        //top:`calc(50% - ${TimelineConstants.RodWidth / 2}px)`,
                        top:TimelineConstants.ThumbOuterDia/2,
                        width:`calc(100% - 32px)`
                    }}
                >
                    {state.thumbs}
                </AltTimelineRod>
                </>
            }
        </TimelineContainer>
    );
}


Timeline.propTypes = {
    id:PropTypes.string,
    kind:PropTypes.oneOf(['pano', 'design']).isRequired,
    items:PropTypes.array.isRequired,
    toolTipPosition:PropTypes.oneOf(['top', 'bottom']).isRequired,
    onItemClick:PropTypes.func,
    startDate:PropTypes.string.isRequired,
    endDate:PropTypes.string.isRequired,
};


Timeline.defaultProps = {
    kind:'pano',
    toolTipPosition:'top',
    items:[]
};


export default Timeline;

export {
    TimelineItemTemplate,
    TimelineItemCategory,
};